import { DocImport } from './Import'
const { RoutesMap, BoqList, DatasheetList } = DocImport

const DocRoute = () => {
    return [
        {
            path: RoutesMap.BOQ_LIST.path,
            element: <BoqList />
        },

        {
            path: RoutesMap.DATASHEET_LIST.path,
            element: <DatasheetList />
        },
    ]
}

export default DocRoute;